import { css } from 'lit';

export const externalStyles = css`
  :host {
    --default-rem-px-count: 16;
  }

  external-online-simple-spec {
    padding-top: calc(16em / var(--default-rem-px-count));
    padding-bottom: calc(20em / var(--default-rem-px-count));

    .red {
      color: red;
    }

    b {
      font-weight: 500;
    }

    .title {
      font-weight: 500;
      padding-bottom: calc(24em / var(--default-rem-px-count));
    }

    .hints {
      padding-bottom: calc(24em / var(--default-rem-px-count));

      .hint {
        span {
          font-weight: 400;
          font-size: 1em;
          letter-spacing: -0.24px;
          line-height: 1.5em;
          margin: 0px;
        }
      }
    }

    app-oss-hardware-solution {
      button {
        background: none;
        color: inherit;
        border: none;
        padding: 0;
        font: inherit;
        cursor: pointer;
        outline: inherit;
      }

      .add-piece-button {
        display: flex;
        gap: calc(6em / var(--default-rem-px-count));
        font-weight: 500;
        padding: calc(20em / var(--default-rem-px-count))
          calc(10em / var(--default-rem-px-count))
          calc(10em / var(--default-rem-px-count));
        font-weight: 500;

        .icon {
          .svg-element {
            padding-top: 1px;
          }
        }
      }

      > div:not(.calculate-container, .oss-systems-wrapper, .oss-hardware-solution-wrapper),
      .section {
        padding-bottom: calc(24em / var(--default-rem-px-count));
        margin-bottom: calc(40em / var(--default-rem-px-count));
        border-bottom: 1px solid #c0c0c0;
      }

      app-oss-point-support,
      app-oss-suspend {
        .system-container {
          .cut-piece-container {
            .cut-piece-item {
              .row-content {
                width: 100%;
                display: flex;
                flex-direction: row;
                padding-top: calc(10em / var(--default-rem-px-count));
                padding-bottom: calc(24em / var(--default-rem-px-count));
                gap: 1.5em 1em;
              }

              .row-content,
              app-item-control-layout,
              .input-label,
              .item-control-input,
              .head-ribbon {
                display: flex;
                flex-direction: row;
                align-items: center;
              }

              .row-content {
                justify-content: space-between;
              }

              .head-ribbon {
                justify-content: space-between;
                align-items: center;
                padding-top: calc(14em / var(--default-rem-px-count));

                .title {
                  padding: 0;
                }

                .action {
                  .cut-piece-button {
                    button {
                      text-decoration: underline;
                      font-size: 0.875em;
                    }
                  }
                }
              }

              /* Override browser defaults */
              input {
                -webkit-appearance: none;
                outline: none;
                box-shadow: none;
                border: none;
                padding: 0;
                background: none;
              }

              input {
                height: calc(48rem / var(--default-rem-px-count));
                width: 100%;
                padding-top: calc(4rem / var(--default-rem-px-count));
                padding-left: calc(16rem / var(--default-rem-px-count));
                display: block;
              }

              input::-webkit-outer-spin-button,
              input::-webkit-inner-spin-button {
                -webkit-appearance: none;
                margin: 0;
              }

              input[type='number'] {
                appearance: textfield;
                -moz-appearance: textfield;
                text-align: center;
                border: 1px solid #c0c0c0;
                padding: 0;
                height: calc(32em / var(--default-rem-px-count));
              }
              input.invalid {
                border: 1px solid red;
              }
              input.col-qty {
                width: 3em;
              }
              input.col-width,
              input.col-height {
                width: 4em;
              }
              .input-label {
                font-weight: 500;
                padding-right: calc(20em / var(--default-rem-px-count));
              }

              .item-control-input {
                .separator {
                  padding: 0 calc(10em / var(--default-rem-px-count));
                  color: #c0c0c0;
                }
              }
            }
          }

          .radio-image-alignment {
            display: grid;
            grid-auto-flow: column;
            grid-auto-columns: 1fr;
            padding-top: calc(16em / var(--default-rem-px-count));

            .option {
              display: flex;
              flex-direction: column;

              label {
                input[type='radio'] {
                  display: inline;
                  font-weight: normal;
                  padding: unset;
                  height: unset;
                  width: unset;
                }

                input:before {
                  content: ' ';
                  display: inline-block;
                  position: relative;
                  top: 5px;
                  margin: 0 5px 0 0;
                  width: 14px;
                  height: 14px;
                  border-radius: 14px;
                  border: 2px solid #ccc;
                  background-color: transparent;
                }

                input:checked::after {
                  position: relative;
                  content: ' ';
                  display: block;
                  background: #ff993d;
                  border-radius: 12px;
                  width: 10px;
                  height: 10px;
                  top: -0.77rem;
                  left: 4px;
                }
              }
            }
          }

          .mat-radio-outer-circle,
          .mat-radio-inner-circle,
          .mat-focus-indicator {
            display: none;
          }

          mat-radio-group {
            display: grid;
            grid-auto-flow: column;
            grid-auto-columns: 1fr;
            padding-top: calc(16em / var(--default-rem-px-count));
          }
          mat-radio-button {
            label {
              display: flex;
              flex-direction: row;
              position: relative;

              .mat-radio-container {
                display: inline-block;
                position: relative;
                padding-bottom: calc(8em / var(--default-rem-px-count));

                input[type='radio'] {
                  font-weight: normal;
                  padding: unset;
                  height: unset;
                }

                input[type='radio']:before {
                  content: ' ';
                  display: inline-block;
                  position: relative;
                  top: 5px;
                  margin: 0 5px 0 0;
                  width: 14px;
                  height: 14px;
                  border-radius: 14px;
                  border: 2px solid #ccc;
                  background-color: transparent;
                }
              }

              .mat-radio-label-content {
                display: flex;
                align-items: center;
              }
            }
          }

          mat-radio-button.mat-radio-checked {
            label {
              display: flex;
              flex-direction: row;
              position: relative;
              .mat-radio-container {
                input[type='radio']:after {
                  position: absolute;
                  content: ' ';
                  display: block;
                  background: #ff993d;
                  border-radius: 12px;
                  width: 10px;
                  height: 10px;
                  top: 12px;
                  left: 9px;
                }
              }
            }
          }

          .flat {
            display: flex;
            flex-direction: row;
            gap: calc(16em / var(--default-rem-px-count));
            align-items: center;

            .item-control-input {
              input {
                height: calc(48rem / var(--default-rem-px-count));
                width: 100%;
                padding-top: calc(4rem / var(--default-rem-px-count));
                padding-left: calc(16rem / var(--default-rem-px-count));
                display: block;
              }

              input::-webkit-outer-spin-button,
              input::-webkit-inner-spin-button {
                -webkit-appearance: none;
                margin: 0;
              }

              input[type='number'] {
                appearance: textfield;
                -moz-appearance: textfield;
                text-align: center;
                border: 1px solid #c0c0c0;
                padding: 0;
                height: calc(32em / var(--default-rem-px-count));
              }
            }
          }
        }
      }

      .calculate-container {
        display: flex;
        flex-direction: row;

        .calculate {
          width: calc(50% - calc(15em / var(--default-rem-px-count)));

          button {
            display: flex;
            flex-direction: row;
            align-items: center;
            border: 1px solid #222222;
            width: 100%;
            height: calc(48em / var(--default-rem-px-count));
            cursor: pointer;
            padding: 0 calc(20em / var(--default-rem-px-count));
          }

          button:after {
            content: '';
            width: 8px;
            height: 14px;
            background: white url('/static/icons/SVG/arrow-black-5x10.svg')
              no-repeat;
            margin-left: auto;
          }

          button:disabled {
            opacity: 0.5;
          }
        }

        .total-label {
          padding-left: calc(30em / var(--default-rem-px-count));
          max-width: 25%;
          display: flex;
          flex-direction: column;

          b {
            padding-bottom: calc(8em / var(--default-rem-px-count));
          }

          .tax {
            text-wrap: balance;
            font-size: 0.875em;
          }
        }

        .spinner {
          margin-left: auto;
        }

        .total-value {
          margin-left: auto;
          font-weight: 500;
        }

        .spinner + .total-value {
          display: none;
        }
      }
    }

    .submit-container {
      padding-top: calc(40em / var(--default-rem-px-count));
      padding-bottom: calc(20em / var(--default-rem-px-count));
      display: flex;
      width: 100%;

      button {
        display: flex;
        flex-direction: row;
        align-items: center;
        border: 1px solid #222222;
        width: calc(50% - calc(15em / var(--default-rem-px-count)));
        height: calc(48em / var(--default-rem-px-count));
        cursor: pointer;
        padding: 0 calc(20em / var(--default-rem-px-count));
        background-color: #222222;
        color: #ffffff;
      }

      button:after {
        content: '';
        width: 8px;
        height: 14px;
        background: url('/static/icons/SVG/arrow-white-5x10.svg') no-repeat;
        margin-left: auto;
      }

      button:disabled {
        opacity: 0.5;
      }
    }
  }
`;
